<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { getTranslation } from '@/composables/data-display-utils';
import { useConsultationsStore } from '@/stores';
import type { ConsultationDto, Locales } from '@/services/types/api.types';

const { t } = useI18n();
const consultationsStore = useConsultationsStore();

// PROPS
const props = defineProps<{
  data: any;
  title: string;
  languageEnabled: Locales[];
}>();

function getStatus(consultation: ConsultationDto) {
  const status = consultationsStore.getConsultationStatuses();
  return status.find((s) => s.value === consultation.status).label;
}

const languageEnabled = props.languageEnabled;

const columns = [
  { name: 'title', field: 'title', sortable: false },
  { name: 'vote_30_days', field: 'votes.30_days', sortable: true },
  { name: 'vote_7_days', field: 'votes.7_days', sortable: true },
  { name: 'vote_last_day', field: 'votes.1_day', sortable: true },
  { name: 'vote_total', field: 'votes.total', sortable: true },
  { name: 'comment_30_days', field: 'comments.30_days', sortable: true },
  { name: 'comment_7_days', field: 'comments.7_days', sortable: true },
  { name: 'comment_last_day', field: 'comments.1_day', sortable: true },
  { name: 'comment_total', field: 'comments.total', sortable: true },
  { name: 'status', field: 'status', sortable: true },
];
</script>

<template>
  <q-table :rows="props.data" :columns="columns" row-key="slug" separator="cell" flat class="participation-table">
    <template v-slot:header>
      <tr>
        <th rowspan="2" style="text-align: center">{{ t('dashboard.participation.consultation') }}</th>
        <th colspan="4" style="text-align: center">{{ t('dashboard.participation.votes') }}</th>
        <th colspan="4" style="text-align: center">{{ t('dashboard.participation.comments') }}</th>
        <th rowspan="2" style="text-align: center">{{ t('dashboard.participation.status') }}</th>
      </tr>
      <tr>
        <th>{{ t('dashboard.participation.last_day') }}</th>
        <th>{{ t('dashboard.participation.7_days') }}</th>
        <th>{{ t('dashboard.participation.30_days') }}</th>
        <th>{{ t('dashboard.participation.total') }}</th>
        <th>{{ t('dashboard.participation.last_day') }}</th>
        <th>{{ t('dashboard.participation.7_days') }}</th>
        <th>{{ t('dashboard.participation.30_days') }}</th>
        <th>{{ t('dashboard.participation.total') }}</th>
      </tr>
    </template>
    <template v-slot:body="props">
      <q-tr :props="props">
        <q-td :props="props" key="title">{{ getTranslation(props.row.consultation, 'title', languageEnabled) }}</q-td>
        <q-td :props="props" key="vote_last_day">{{ props.row.votes['1_day'] }}</q-td>
        <q-td :props="props" key="vote_7_days">{{ props.row.votes['7_days'] }}</q-td>
        <q-td :props="props" key="vote_30_days">{{ props.row.votes['30_days'] }}</q-td>
        <q-td :props="props" key="vote_total">{{ props.row.votes.total }}</q-td>
        <q-td :props="props" key="comment_last_day">{{ props.row.comments['1_day'] }}</q-td>
        <q-td :props="props" key="comment_7_days">{{ props.row.comments['7_days'] }}</q-td>
        <q-td :props="props" key="comment_30_days">{{ props.row.comments['30_days'] }}</q-td>
        <q-td :props="props" key="comment_total">{{ props.row.comments.total }}</q-td>
        <q-td :props="props" key="status">{{ getStatus(props.row.consultation) }}</q-td>
      </q-tr>
    </template>
  </q-table>
</template>
<style lang="scss">
.participation-table {
  width: inherit;
  margin: 10px;
  border: 1px solid rgba(230, 230, 230, 0.8);
  border-radius: 8px !important;
}
</style>
